import axios from "axios";

export default function EntrylocationInviteSubcontractorByNetworkService(formData) {
  return axios({
    method: 'post',
    url: process.env.REACT_APP_API_HOST + "/entry_location/" + localStorage.getItem("networkId") + "/invite_subcontractor/byNetwork",
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
